<template>
  <div id="app">
    <LoginVue />
    <Beian />
  </div>
</template>

<script>
import LoginVue from './components/Login.vue';
import Beian from './components/BeiAnCom.vue';
export default {
  name: 'App',
  components: {
    LoginVue,
    Beian,
  },
};
</script>

<style>
html,
body {
  margin: 0px;
  padding: 0px;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
</style>
